export const SITE_URL = 'https://speakenglishnow.es';
export const COURSE_LOGIN_URL = 'https://www.speakenglishnow.club/en/login?redirectUrl=https%3A%2F%2Fwww.speakenglishnow.club%2Fschool%2Fcourse%2Facceso';
export const CLASSES_LOGIN_URL = 'https://sen.schoolmate.eu/';
export const WHATSAPP_NUMBER = '34650492859';
export const CONTACT_EMAIL = 'info@speakenglishnow.club';

export const SERVICE_AREAS = ['Mataró', 'El Maresme', 'Barcelona', 'Cataluña', 'España'];

export const ORGANIZATION_SCHEMA = {
  '@type': 'EducationalOrganization',
  '@id': `${SITE_URL}/#organization`,
  name: 'Speak English Now',
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/media/brand-horizontal.png`,
  image: `${SITE_URL}/media/editorial/caroline-fundadora.webp`,
  description: 'Clases de inglés online para toda España y formación presencial en Barcelona, Mataró y alrededores, con una metodología práctica centrada en la comunicación.',
  foundingDate: '2006',
  founder: { '@type': 'Person', name: 'Caroline Franks' },
  telephone: '+34650492859',
  email: CONTACT_EMAIL,
  areaServed: SERVICE_AREAS.map(name => ({ '@type': 'AdministrativeArea', name })),
  knowsAbout: ['Aprender inglés', 'Inglés online', 'Conversación en inglés', 'Preparación Cambridge FCE y CAE', 'Inglés para empresas'],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+34650492859',
    contactType: 'customer service',
    areaServed: 'ES',
    availableLanguage: ['es', 'en'],
  },
  sameAs: [
    'https://www.facebook.com/SpeakEnglishNow21',
    'https://www.instagram.com/speakenglishnow06/',
    'https://www.tiktok.com/@speakenglishnow',
    'https://www.youtube.com/@speakenglishnow06/videos',
  ],
};

export const whatsappUrl = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const MEDIA = {
  logo: '/media/brand-horizontal.png',
  logoMark: '/media/brand-icon.png',
  caroline: '/media/caroline-tiktok.webp',
  carolineAvatar: '/media/caroline-avatar.webp',
  carolinePortrait: '/media/team/caroline.webp',
  carolineHome: '/media/editorial/caroline-fundadora.webp',
  carolineAboutHero: '/media/editorial/caroline-gala.webp',
  carolineCourse: '/media/editorial/caroline-sen-pro.webp',
  carolineBookCoast: '/media/editorial/caroline-libro-costa.webp',
  bookPresentation: '/media/editorial/presentacion-libro.webp',
  carolineZulema: '/media/editorial/caroline-zulema.webp',
  carolineConference: '/media/editorial/caroline-conferencia.webp',
  groupStudentsAteneu: '/media/editorial/grupo-alumnos-ateneu.webp',
  bookPresentationPhoto: '/media/editorial/caroline-libro-presentacion.webp',
  bookSigningPhoto: '/media/editorial/caroline-firma-libro.webp',
  team: '/media/new/equipo-sen.jpg',
  onlineClass: '/media/new/clase-online.webp',
  courseLesson: '/media/new/plataforma-leccion.webp',
  courseModules: '/media/new/plataforma-modulos.webp',
  businessInsider: '/media/new/business-insider.webp',
  pressCincoDias: '/media/press/cinco-dias.webp',
  pressElMundo: '/media/press/el-mundo.webp',
  pressInnovacion: '/media/press/innovacion-educativa.webp',
  pressZona: '/media/press/zona-movilidad.webp',
  pressApplicantes: '/media/press/applicantes.webp',
  carolineBook: '/media/caroline-libro.webp',
  tiktokStage: '/media/premios-tiktok-escenario.webp',
  tiktokGala: '/media/premios-tiktok-gala.webp',
  tiktokNomination: '/media/nominacion-tiktok.webp',
  hermanosTorres: '/media/hermanos-torres.webp',
  keilin: '/media/keilin-caroline.webp',
  keilinVertical: '/media/keilin-caroline-vertical.webp',
  berta: '/media/berta-caroline.webp',
  bertaRecommendation: '/media/berta-recomendacion.webp',
  presentationPoster: '/media/poster-presentacion.webp',
  vslPoster: '/media/poster-vsl.webp',
  keilinPoster: '/media/poster-keilin.webp',
  pressPoster: '/media/poster-prensa.webp',
  galaPoster: '/media/poster-gala.webp',
  robertoPoster: '/media/poster-roberto.webp',
  presentationVideo: '/media/videos/caroline-presentacion-lite.mp4',
  vslVideo: '/media/videos/curso-vsl-lite.mp4',
  keilinVideo: '/media/videos/testimonio-keilin-lite.mp4',
  pressVideo: '/media/videos/aparicion-prensa-lite.mp4',
  galaVideo: '/media/videos/gala-tiktok-lite.mp4',
  robertoCourseVideo: '/media/videos/testimonio-roberto-sen-pro-lite.mp4',
};

export const verifiedTestimonials = [
  {
    name: 'Berta Santos Rouco',
    role: 'Alumna · Executive coach',
    avatar: MEDIA.berta,
    quote: 'Las clases de inglés con Caroline han supuesto una experiencia única, había recibido muchas clases de inglés, pero Caroline ha trabajado conmigo algo más importante que la gramática y el speaking, la mentalidad y las creencias sobre el inglés, la confianza para hablar una lengua extranjera, lo que ha supuesto ver el inglés como lo que realmente es: la posibilidad de comunicación en otro idioma. Todo ello con tacto, paciencia y desbloqueando cada uno de los obstáculos que me impedían comunicarme en inglés de forma natural. Gracias Caroline por toda tu paciencia, y por enseñarme a disfrutar hablando un idioma que me encanta.',
  },
  {
    name: 'Keilin Aguilar',
    role: 'Alumna de Speak English Now',
    avatar: MEDIA.keilin,
    quote: 'Keilin comparte en vídeo su experiencia personal aprendiendo inglés con Caroline.',
  },
];
